import React from 'react'
import { FormattedMessage } from 'react-intl'
import getLabelByValue from 'sr/helpers/functions/getLabelByValue'
import Pill from 'sr/helpers/ui-components/Pill'

export const ReviewDataEdit = (props) => {
  const {
    title,
    value,
    multivalue,
    onClick,
    allData,
    options,
    type = 'text'
  } = props;

  const formatValue = (val) => {
    if (!val || val === '') return 'NA';
    
    switch (type) {
      case 'date':
        return new Date(val).toLocaleDateString();
      case 'currency':
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD'
        }).format(Number(val));
      default:
        if (options && Array.isArray(options)) {
          const option = options.find(opt => opt.value === val);
          return option ? (
            <FormattedMessage id={option.label} defaultMessage={option.label} />
          ) : val;
        }
        return val;
    }
  };

  const formatMultiValue = (items) => {
    if (!items || !Array.isArray(items) || items.length === 0) return ['NA'];
    
    return items.map(item => {
      if (options && Array.isArray(options)) {
        const option = options.find(opt => opt.value === item);
        return option ? (
          <FormattedMessage id={option.label} defaultMessage={option.label} />
        ) : item;
      }
      return item;
    });
  };

  return (
    <div className='bg-white rounded-lg border border-gray-200  p-4'>
      <div className='flex items-center justify-between mb-3'>
        <p className='text-base font-semibold text-gray-800'>
          {title}
        </p>
        <button
          onClick={onClick}
          className="text-[#0078ae] hover:text-blue-800 transition-colors p-1 rounded-full hover:bg-blue-50"
          aria-label={`Edit ${title}`}
        >
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            fill="currentColor" 
            viewBox="0 0 24 24" 
            className="w-5 h-5"
          >
            <path d="M20.706 7.042a.996.996 0 000-1.41l-2.34-2.34a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83zm-2.898 2.9l-9.705 9.71a.5.5 0 01-.218.128l-4.246 1.2a.5.5 0 01-.618-.616l1.209-4.24a.5.5 0 01.127-.216l9.7-9.716 3.75 3.75z"></path>
          </svg>
        </button>
      </div>
      
      {multivalue ? (
        <div className="flex flex-wrap gap-2">
          {formatMultiValue(multivalue).map((item, index) => (
            <Pill key={index}>{item}</Pill>
          ))}
        </div>
      ) : (
        <p className="text-gray-700">
          {formatValue(value)}
        </p>
      )}
    </div>
  )
}
